import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tabs, Tab } from 'react-bootstrap';
import Spinner from '../../../../components/Spinner';
import PendingFilingsListGrid from './PendingFilingsListGrid';
import CancelledFilingsListGrid from './CancelledFilingsListGrid';
import RecentExemptedFilingsListGrid from './RecentExemptedFilingsListGrid';
import PendingAmendmentsListGrid from './PendingAmendmentsListGrid';

import {
    fetchFilingById,
    fetchPendingFilings,
    fetchCancelledFilings,
    fetchRecentExemptedFilings,
    fetchPendingAmendments,
    updateFilingInfoData,
    updateSelectedFilingList,
    holdFiling,
    cancelFiling,
    setPendingFiling,
    fetchClientData,
    fetchStateData,
    inProgressFilingList
} from '../../../../services/redux/employee/filing/actions';
import ConfirmDialog from '../../../../components/Dialog/ConfirmDialog';
import Panel from '../../../../components/angle/Panel';

class PendingFilings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmHeader: 'Cancel Filing',
            confirmText:
                'Are you sure? This action cannot be undone. If you need to file again you need to resubmit.',
            confirmIsShowing: false
        };
    }

    componentDidMount() {
        let {
            fetchPendingFilings,
            fetchCancelledFilings,
            fetchRecentExemptedFilings,
            fetchPendingAmendments
        } = this.props;
        fetchPendingFilings();
        fetchCancelledFilings();
        fetchRecentExemptedFilings();
        fetchPendingAmendments();
    }

    reviewPendingFiling = selected => {
        let {
            history,
            fetchFilingById,
            fetchClientData,
            fetchStateData,
            updateFilingInfoData
        } = this.props;

        fetchFilingById(selected.filingId);
        updateFilingInfoData(selected);
        if (selected.clientId) {
            fetchClientData(selected.clientId);
        }
        if (selected.stateId) {
            fetchStateData(selected.stateId);
        }
        history.push({ pathname: '/filing-details', from: '/pending-filings' });
    };

    holdPendingFiling = selected => {
        let {
            holdFiling,
            fetchPendingFilings,
            fetchCancelledFilings
        } = this.props;
        if (selected.approvedStatus === 4) {
        } else {
            holdFiling(selected.filingId).then(() => {
                fetchPendingFilings();
                fetchCancelledFilings();
            });
        }
    };

    removeHoldPendingFiling = selected => {
        let {
            setPendingFiling,
            fetchPendingFilings,
            fetchCancelledFilings
        } = this.props;
        setPendingFiling(selected.filingId).then(() => {
            fetchPendingFilings();
            fetchCancelledFilings();
        });
    };

    cancelPendingFiling = () => {
        let {
            cancelFiling,
            fetchPendingFilings,
            fetchCancelledFilings
        } = this.props;

        cancelFiling(this.state.cancelFilingData.filingId).then(() => {
            fetchPendingFilings();
            fetchCancelledFilings();
        });

        this.hideCancelFilingConfirm();
    };

    showCancelFilingConfirm = data => {
        this.setState({
            confirmIsShowing: true,
            cancelFilingData: data
        });
    };

    hideCancelFilingConfirm = () => {
        this.setState({
            confirmIsShowing: false
        });
    };

    onInProgressAllClick = () => {
        let {
            filing,
            inProgressFilingList,
            fetchPendingFilings,
            fetchCancelledFilings
        } = this.props;
        let selectedFilingIds = filing.selectedFilings.map(
            filing => filing.filingId
        );
        inProgressFilingList(selectedFilingIds).then(() => {
            fetchPendingFilings();
            fetchCancelledFilings();
        });
    };

    render() {
        let { filing, updateSelectedFilingList, roleName } = this.props;
        let { confirmHeader, confirmText, confirmIsShowing } = this.state;
        let isAdmin = roleName === 'Administrator';
        let inProgressAllButton = isAdmin && (
            <button
                key="inProgressAllButton"
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onInProgressAllClick}
                disabled={filing.selectedFilings.length === 0}
            >
                In progress all
            </button>
        );
        return (
            <div>
                <ConfirmDialog
                    header={confirmHeader}
                    content={confirmText}
                    isShowing={confirmIsShowing}
                    onConfirm={this.cancelPendingFiling}
                    onCancel={this.hideCancelFilingConfirm}
                />
                <div role="tabpanel" className="panel">
                    <Tabs
                        defaultActiveKey={1}
                        id="tabID"
                        className="grid-tab-content"
                        mountOnEnter={true}
                    >
                        <Tab
                            eventKey={1}
                            title={
                                <div>
                                    Pending Confirmations{' '}
                                    <span className="badge">
                                        {filing.pendingFilings.length}
                                    </span>
                                </div>
                            }
                        >
                            <Panel
                                showFooter={true}
                                footerComponents={[inProgressAllButton]}
                            >
                                <PendingFilingsListGrid
                                    id="pendingFilingsGrid"
                                    dataList={filing.pendingFilings}
                                    showReviewColumn={true}
                                    handleReviewButtonClick={
                                        this.reviewPendingFiling
                                    }
                                    showHoldCancelColumn={true}
                                    handleHoldButtonClick={
                                        this.holdPendingFiling
                                    }
                                    handleCancelButtonClick={
                                        this.showCancelFilingConfirm
                                    }
                                    updateSelected={updateSelectedFilingList}
                                />
                            </Panel>
                        </Tab>
                        <Tab
                            eventKey={2}
                            title={
                                <div>
                                    Cancelled Filings{' '}
                                    <span className="badge">
                                        {filing.cancelledFilings.length}
                                    </span>
                                </div>
                            }
                        >
                            <CancelledFilingsListGrid
                                id="cancelledFilingsGrid"
                                dataList={filing.cancelledFilings}
                                handleRemoveHoldButtonClick={
                                    this.removeHoldPendingFiling
                                }
                            />
                        </Tab>
                        <Tab
                            eventKey={3}
                            title={
                                <div>
                                    Recent Exemptions{' '}
                                    <span className="badge">
                                        {filing.recentExemptedFilings.length}
                                    </span>
                                </div>
                            }
                        >
                            <RecentExemptedFilingsListGrid
                                id="exemptFilingsGrid"
                                dataList={filing.recentExemptedFilings}
                            />
                        </Tab>
                        <Tab
                            eventKey={4}
                            title={
                                <div>
                                    Pending Amendments{' '}
                                    <span className="badge">
                                        {filing.pendingAmendments.length}
                                    </span>
                                </div>
                            }
                        >
                            <PendingAmendmentsListGrid
                                id="pendingAmendmentsGrid"
                                dataList={filing.pendingAmendments}
                            />
                        </Tab>
                    </Tabs>
                    {filing.fetching && <Spinner />}
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => ({
    filing: state.employee.filing,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchFilingById,
            fetchPendingFilings,
            fetchCancelledFilings,
            fetchRecentExemptedFilings,
            fetchPendingAmendments,
            updateFilingInfoData,
            updateSelectedFilingList,
            holdFiling,
            cancelFiling,
            setPendingFiling,
            fetchClientData,
            fetchStateData,
            inProgressFilingList
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(PendingFilings));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/PendingFilings/index.js